export const CLEAR_DRIVE = '@@drive/CLEAR_DRIVE'

export interface ClearDriveAction {
	type: typeof CLEAR_DRIVE
}
